/**
 * DEBUG - Utilitário centralizado de log para desenvolvimento.
 * Só emite saída quando:
 * - No browser: import.meta.env.DEV ou localStorage.getItem('DEBUG') ou ?debug=1
 * - Em Node/Deno: process.env.DEBUG ou Deno.env.get('DEBUG')
 */

const isDev =
  typeof import.meta !== "undefined" && (import.meta as { env?: { DEV?: boolean } }).env?.DEV === true;

function isDebugEnabled(): boolean {
  if (typeof window !== "undefined") {
    if (isDev) return true;
    try {
      if (localStorage.getItem("DEBUG") === "1" || localStorage.getItem("DEBUG") === "true") return true;
      if (typeof URLSearchParams !== "undefined" && new URLSearchParams(window.location.search).get("debug") !== null)
        return true;
    } catch {
      /* ignore */
    }
    return false;
  }
  if (typeof process !== "undefined" && process.env?.DEBUG) return true;
  if (typeof Deno !== "undefined" && Deno.env?.get?.("DEBUG")) return true;
  return isDev;
}

let _enabled: boolean | null = null;

function enabled(): boolean {
  if (_enabled === null) _enabled = isDebugEnabled();
  return _enabled;
}

/**
 * Log de debug. Só imprime quando DEBUG está ativo.
 * @param tag - Identificador do módulo/fluxo (ex: "deadline", "supabase", "AiPetitions")
 * @param message - Mensagem opcional
 * @param data - Dados opcionais (objetos são passados ao console para inspeção)
 */
export function DEBUG(
  tag: string,
  message?: string,
  data?: unknown
): void {
  if (!enabled() || !isDev) return;
  const prefix = `[DEBUG:${tag}]`;
  if (data !== undefined) {
    if (message !== undefined) {
      console.log(prefix, message, data);
    } else {
      console.log(prefix, data);
    }
  } else if (message !== undefined) {
    console.log(prefix, message);
  } else {
    console.log(prefix);
  }
}

/**
 * Força reavaliação do estado DEBUG na próxima chamada (útil após mudar localStorage ou query).
 */
export function DEBUG_reset(): void {
  _enabled = null;
}
